import React, { forwardRef } from "react";
import { ReactComponent as ChevronDownIcon } from "../../../icons/chevronDown.svg";
import {
  InputWithOptions,
  InputWithOptionsProps,
} from "../InputWithOptions/InputWithOptions";

export type SelectOption<T> = {
  value: T;
  label: string;
};

interface AutoCompleteProps<T> extends InputWithOptionsProps<T> {
  loading?: boolean;
  disabled?: boolean;
}

function AutoCompleteInner<T extends string | number>(
  { onChange, loading, allowClear = true, ...props }: AutoCompleteProps<T>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const onSelectOption = (value: T | null) => {
    if (onChange) {
      onChange(value ? value.toString() : "");
    }
  };

  return (
    <InputWithOptions
      ref={ref}
      allowClear={allowClear}
      endIcon={<ChevronDownIcon />}
      onSelectOption={onSelectOption}
      loading={loading}
      onChange={onChange}
      {...props}
    />
  );
}

export const AutoComplete = forwardRef(AutoCompleteInner) as <
  T extends string | number,
>(
  props: AutoCompleteProps<T> & React.RefAttributes<HTMLDivElement>,
) => ReturnType<typeof AutoCompleteInner>;
